import { EPaymentInitSource } from '../../types/redux/checkout';
import { getPaymentMethods } from '../../services/common/getPaymentMethods';
import { IGetPaymentMethodsResult } from '../../services/common/getPaymentMethods/types';
import { setPaymentMethods } from '../../actions/paymentMethods';
import { loadPaymentProvidersScripts } from '../../services/common/loadPaymentProvidersScripts';
import { TThunkAction } from '../../types/redux';

interface IParams {
  paymentInitSource: EPaymentInitSource;
}

export const loadPaymentMethodsThunk =
  (params: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, telemetry }) => {
    const { paymentInitSource } = params;

    const { paymentProviders, ...paymentMethods }: IGetPaymentMethodsResult = await getPaymentMethods({
      httpApi,
      paymentInitSource,
    });

    dispatch(setPaymentMethods(paymentMethods));

    await loadPaymentProvidersScripts({ paymentProviders, telemetry });
  };
